export const vi = {
  common: {
    save: 'Lưu',
    cancel: 'Hủy',
    delete: 'Xóa',
    close: 'Đóng',
    loading: 'Đang tải...',
    dismissNotification: 'Đóng thông báo',
    notifications: 'Thông báo',
    wordmark: 'REDA GALLERY · ARCHIVE & STUDIO',
  },
  errorBoundary: {
    title: 'Đã xảy ra lỗi kết nối',
    body: 'Không thể hiển thị không gian triển lãm. Vui lòng tải lại.',
    reload: 'Tải lại trang',
  },
  auth: {
    kicker: 'Reda Gallery · Archival Studio',
    theme: {
      toLight: 'Chuyển sang giao diện sáng',
      toDark: 'Chuyển sang giao diện tối',
    },
    title: {
      login: 'Xưởng quản lý',
      register: 'Tạo quyền truy cập',
    },
    subtitle: {
      login: 'Đăng nhập để quản lý các triển lãm 3D, ánh sáng không gian và các gian âm thanh không gian.',
      register: 'Đăng ký làm người quản lý triển lãm để sáng tác và xuất bản các phòng trưng bày nghệ thuật kiến trúc.',
    },
    modeSwitch: {
      ariaLabel: 'Lựa chọn xác thực',
      signIn: 'Đăng nhập',
      register: 'Đăng ký',
    },
    google: {
      title: 'Xác thực qua Google Workspace',
      cta: 'Tiếp tục với Google',
    },
    divider: 'hoặc bằng thông tin đăng nhập',
    fields: {
      fullName: {
        label: 'Họ và tên người quản lý',
        placeholder: 'Elena Rostova',
      },
      email: {
        label: 'Email người quản lý',
        placeholder: 'curator@gallery.org',
      },
      password: {
        label: 'Mật khẩu',
        placeholder: '••••••••••••',
      },
    },
    password: {
      show: 'Hiện mật khẩu',
      hide: 'Ẩn mật khẩu',
      showShort: 'Hiện',
      hideShort: 'Ẩn',
    },
    submit: {
      loading: 'Đang xác thực…',
      login: 'Đăng nhập bằng mật khẩu',
      register: 'Tạo tài khoản người quản lý',
    },
    footer: {
      security: 'Phiên làm việc được mã hóa · Kiến trúc Cloudflare D1',
    },
    errors: {
      loginFailed: 'Đăng nhập thất bại',
      registrationFailed: 'Đăng ký thất bại',
      sessionVerifyFailed: 'Xác thực thành công, nhưng không thể xác minh phiên làm việc. Vui lòng thử đăng nhập lại.',
      networkError: 'Lỗi mạng khi xác thực. Vui lòng kiểm tra kết nối internet.',
    },
    account: {
      backAria: 'Quay lại trang tổng quan',
      backText: 'Quay lại danh sách triển lãm',
      brandSubtitle: 'Quản lý tài khoản',
      title: 'Tài khoản của bạn',
      description: 'Thông tin cá nhân, hồ sơ người quản lý và cài đặt bảo mật.',
      profileTitle: 'Thông tin hồ sơ',
      curatorFallback: 'Người quản lý',
      role: 'Vai trò: {role}',
      curatorProfile: 'Hồ sơ người quản lý',
      fullNameLabel: 'Họ và tên',
      emailLabel: 'Email',
      emailHint: 'Email dùng để đăng nhập; không thể thay đổi.',
      securityTitle: 'Bảo mật',
      currentPasswordLabel: 'Mật khẩu hiện tại',
      newPasswordLabel: 'Mật khẩu mới',
      newPasswordHint: 'Tối thiểu 8 ký tự.',
      confirmPasswordLabel: 'Xác nhận mật khẩu mới',
      passwordPlaceholder: '••••••••',
      passwordMismatch: 'Mật khẩu không khớp.',
      submit: 'Đổi mật khẩu',
      submitLoading: 'Đang cập nhật mật khẩu…',
      toastSuccess: 'Mật khẩu đã được cập nhật thành công.',
      toastErrorFallback: 'Không thể đổi mật khẩu. Vui lòng kiểm tra mật khẩu hiện tại.',
      toastNetworkError: 'Lỗi kết nối khi đổi mật khẩu.',
    },
  },
  dashboard: {
    title: 'Triển lãm của bạn',
    accountAria: 'Quản lý tài khoản của bạn',
    newExhibition: 'Triển lãm mới',
    signOut: 'Đăng xuất',
    loading: 'Đang tải danh sách triển lãm…',
    emptyAria: 'Chưa có triển lãm nào',
    emptyTitle: 'Bạn chưa có triển lãm nào',
    emptyDescription: 'Bắt đầu quản lý triển lãm 3D đầu tiên của bạn — chọn tác phẩm, xây dựng câu chuyện nghệ thuật và xuất bản phòng trưng bày 3D.',
    emptyCta: 'Tạo triển lãm đầu tiên',
    newCardAria: 'Tạo triển lãm mới',
    badge: {
      live: 'Đang hiển thị',
      draft: 'Bản nháp',
    },
    card: {
      meta: '{count} tác phẩm · {room}',
      noRoom: 'Chưa có phòng',
      curator: 'Người quản lý · {name}',
      edit: 'Chỉnh sửa & quản lý',
      view: 'Xem 3D',
      share: 'Chia sẻ',
      shareTitle: 'Chia sẻ {title}',
      deleteAria: 'Xóa {title}',
      confirmDelete: 'Xác nhận xóa',
    },
    newForm: {
      title: 'Tạo triển lãm mới',
      titleLabel: 'Tên triển lãm *',
      titlePlaceholder: 'ví dụ: Góc Nhìn Hiện Đại 2026',
      curatorLabel: 'Tên người quản lý',
      curatorPlaceholder: 'ví dụ: Elena Rostova',
      spaceLabel: 'Không gian 3D *',
      libraryRoom: 'Phòng thư viện nền tảng',
      customSpace: 'Không gian 3D tùy chỉnh (.GLB)',
      selectRoom: 'Chọn phòng trưng bày',
      platformLibrarySuffix: '(Thư viện nền tảng)',
      customRoomSuffix: '(Phòng tùy chỉnh)',
      customRoomNameLabel: 'Tên không gian tùy chỉnh',
      customRoomNamePlaceholder: 'ví dụ: Gian Trưng Bày Tối Giản Hiện Đại',
      glbLabel: 'Liên kết Google Drive hoặc File ID (mô hình .GLB) *',
      glbPlaceholder: 'https://drive.google.com/file/d/... hoặc File ID',
      descriptionLabel: 'Lời giới thiệu / Mô tả triển lãm',
      descriptionPlaceholder: 'Tổng quan về triển lãm...',
      submit: 'Tạo & bắt đầu quản lý',
      submitLoading: 'Đang tạo…',
      errors: {
        missingGlb: 'Vui lòng cung cấp liên kết Google Drive, File ID hoặc URL mô hình 3D cho không gian tùy chỉnh.',
        createRoomFailed: 'Không thể tạo không gian 3D tùy chỉnh: {detail}',
        networkError: 'Lỗi mạng. Vui lòng thử lại.',
      },
    },
  },
  studio: {
    appLoading: {
      kicker: 'Reda Atelier',
      text: 'Đang kết nối đến Kho lưu trữ của người quản lý…',
    },
    transitions: {
      hotspot: {
        arc_dip: {
          label: 'Bay vòng cung điện ảnh',
          description: 'Chuyển động mượt như flycam, có một vòng cung zoom lùi nhẹ giữa chừng.',
        },
        linear_glide: {
          label: 'Lướt thẳng & thu phóng',
          description: 'Quỹ đạo trực tiếp mượt mà, lướt thẳng qua khung tranh.',
        },
        deep_pullback: {
          label: 'Lùi xa toàn cảnh ấn tượng',
          description: 'Kéo camera lùi ra toàn cảnh tác phẩm trước khi lao vào.',
        },
        instant_cut: {
          label: 'Chuyển cảnh tức thì',
          description: 'Chuyển góc camera dứt khoát với một cú lắng nhẹ nhanh gọn.',
        },
        spring_overshoot: {
          label: 'Bật nảy đàn hồi',
          description: 'Chuyển động camera linh hoạt với một cú nảy nhẹ đầy năng lượng khi đến nơi.',
        },
      },
      intro: {
        fade: {
          label: 'Hòa mờ mượt mà',
          description: 'Hiệu ứng tan hòa cổ điển liền mạch vào phòng triển lãm 3D.',
        },
        zoom_in: {
          label: 'Lao vào điện ảnh',
          description: 'Phóng to tiến thẳng qua video để vào không gian 3D.',
        },
        blur_fade: {
          label: 'Tan mờ ảo diệu',
          description: 'Hiệu ứng mờ quang học nhẹ nhàng tan vào phòng trưng bày 3D sắc nét.',
        },
        iris_circle: {
          label: 'Mở khẩu độ tròn',
          description: 'Vòng tròn khẩu độ ấn tượng mở rộng ra từ tâm.',
        },
        slide_up: {
          label: 'Kéo màn sân khấu',
          description: 'Màn sân khấu kéo lên đầy kịch tính để hé lộ không gian.',
        },
        flash_white: {
          label: 'Bừng sáng phòng trưng bày',
          description: 'Ánh sáng bừng nghệ thuật lan tỏa vào phòng.',
        },
      },
    },
    statusBar: {
      workCount: '{count} tác phẩm',
      mode: 'Chế độ',
    },
    toolRail: {
      curate: 'Quản lý',
      rooms: 'Phòng',
      artists: 'Họa sĩ',
      setup: 'Cài đặt',
    },
    artistsPane: {
      title: 'Họa sĩ',
      addAria: 'Thêm họa sĩ',
      noDates: 'Chưa có niên đại',
    },
    artworksPane: {
      title: 'Tác phẩm',
      addAria: 'Thêm tác phẩm',
      addTitle: 'Thêm tác phẩm mới',
      placementStatusAria: 'Trạng thái sắp đặt tác phẩm',
      inRoomTab: 'Trong phòng ({count})',
      inRoomTitle: 'Tác phẩm hiện đang treo trên tường trong phòng 3D',
      storageTab: 'Lưu kho ({count})',
      storageTitle: 'Tác phẩm được lưu trữ để sắp đặt sau',
      filterTitle: 'Lọc tác phẩm theo họa sĩ',
      filterAll: 'Lọc: Tất cả họa sĩ ({count})',
      filterUnassigned: 'Chưa gán ({count})',
      emptyFiltered: 'Không có tác phẩm nào khớp với bộ lọc họa sĩ trong tab này.',
      emptyInRoom: 'Không có tác phẩm nào trong phòng. Hãy đặt một tác phẩm từ Lưu kho hoặc nhấn + để thêm.',
      emptyStorage: 'Không có tác phẩm lưu kho. Tác phẩm được chuyển ra khỏi phòng sẽ xuất hiện ở đây.',
    },
    inspector: {
      resizeTitle: 'Kéo để đổi cỡ khung thông tin',
      newArtwork: 'Tác phẩm mới',
      closeAria: 'Đóng khung thông tin',
    },
    shareModal: {
      title: 'Chia sẻ triển lãm',
      closeAria: 'Đóng hộp thoại chia sẻ',
      downloadQr: 'Tải mã QR (PNG)',
      publicLinkLabel: 'Liên kết công khai triển lãm',
      copyLink: 'Sao chép liên kết',
      copied: 'Đã sao chép!',
      qrAlt: 'Mã QR cho {title}',
      exploreShareText: 'Khám phá "{title}" trên REDA Virtual Gallery',
      socialShareText: 'Khám phá "{title}" trên REDA Virtual Gallery: ',
      nativeShare: 'Chia sẻ qua thiết bị…',
      social: {
        facebook: 'Chia sẻ trên Facebook',
        x: 'Chia sẻ trên X',
        linkedin: 'Chia sẻ trên LinkedIn',
        whatsapp: 'Chia sẻ trên WhatsApp',
        telegram: 'Chia sẻ trên Telegram',
        email: 'Chia sẻ qua Email',
      },
    },
    drivePicker: {
      pickFromDrive: 'Chọn từ Google Drive',
      opening: 'Đang mở…',
      shareGrantFailed: 'Đã chọn tệp, nhưng không thể cấp quyền truy cập cho tài khoản dịch vụ Reda. Tệp có thể không tải được cho đến khi bạn chia sẻ thủ công với tài khoản dịch vụ.',
    },
    settingsSidebar: {
      ariaLabel: 'Phím tắt & điều khiển Studio',
      title: 'Điều khiển 3D Studio',
      closeAria: 'Đóng cài đặt',
      keyboardNav: 'Điều hướng bàn phím',
      remapHint: 'Nhấn vào nút bất kỳ để gán lại phím',
      keys: {
        forward: 'Di chuyển tới',
        backward: 'Di chuyển lùi',
        strafeLeft: 'Dịch trái',
        strafeRight: 'Dịch phải',
        elevateUp: 'Nâng lên',
        lowerDown: 'Hạ xuống',
        sprintBoost: 'Tăng tốc chạy',
      },
      rebindTitle: 'Nhấn rồi bấm một phím để gán lại',
      pressKey: 'Nhấn phím…',
      mouseBehavior: 'Hành vi chuột & tốc độ',
      rightClickAction: 'Hành động kéo chuột phải',
      rightClickActionDesc: 'Khi một tác phẩm đang được chọn, kéo trực tiếp để di chuyển nó trong không gian 3D.',
      moveFocusedArtwork: 'Di chuyển tác phẩm đang chọn',
      alwaysPanCamera: 'Luôn xoay camera',
      cameraMoveSpeed: 'Tốc độ di chuyển camera',
      cameraMoveSpeedDesc: 'Tốc độ điều hướng WASD ở chế độ soạn thảo',
      cameraPanSpeed: 'Tốc độ xoay camera',
      cameraPanSpeedDesc: 'Tốc độ xoay mượt khi kéo chuột phải',
      dragSensitivity: 'Độ nhạy di chuyển trực tiếp',
      dragSensitivityDesc: 'Độ nhạy khi kéo chuột phải để di chuyển tác phẩm',
      cheatSheetTitle: 'Bảng tra cứu điều khiển',
      cheatSheet: {
        leftClickLabel: 'Chuột trái',
        leftClick: 'Chọn tác phẩm / nhấn nền hoặc Esc để bỏ chọn',
        middleDragLabel: 'Kéo chuột giữa',
        middleDrag: 'Xoay 360° quanh khung nhìn / tiêu điểm chuột',
        rightDragLabel: 'Kéo chuột phải',
        rightDrag: 'Di chuyển tác phẩm đang chọn (hoặc xoay camera khi không chọn)',
        wasdLabel: 'WASD / Phím mũi tên',
        wasd: 'Di chuyển tự do trong phòng trưng bày',
        shiftLabel: 'Shift',
        shift: 'Tăng tốc độ di chuyển',
        escLabel: 'Esc',
        esc: 'Bỏ chọn để về chế độ di chuyển tự do',
      },
      resetDefaults: 'Đặt lại mặc định',
      done: 'Xong',
    },
    roomImporter: {
      header: 'Kiến trúc phòng trưng bày',
      selectRoomTab: 'Chọn phòng ({count} khả dụng)',
      addCustomTab: '+ Thêm phòng GLB tùy chỉnh',
      chooseSpace: 'Chọn một không gian trưng bày…',
      customRoomSuffix: '(Phòng tùy chỉnh)',
      builtInSuffix: '(Phòng trưng bày có sẵn)',
      noRoomsHintPrefix: 'Chưa có phòng nào được tải. Nhấn',
      noRoomsHintSuffix: 'để thêm một phòng.',
      step1Name: '1. Tên phòng',
      namePlaceholder: 'ví dụ: Gian Trưng Bày Hiện Đại',
      step2Source: '2. Nguồn mô hình 3D (Liên kết Google Drive hoặc URL GLB trực tiếp)',
      pickGlbButton: 'Chọn GLB từ Google Drive',
      sourcePlaceholder: 'https://drive.google.com/file/d/1A2B3C... hoặc https://example.com/model.glb',
      driveHintLabel: 'Đối với Google Drive:',
      driveHintText: 'Đảm bảo tệp đã được chia sẻ với tài khoản dịch vụ Reda và dán liên kết vào đây.',
      urlHintLabel: 'Đối với URL trực tiếp:',
      urlHintText: 'Phải là tệp',
      urlHintSuffix: 'công khai có đuôi',
      step3Check: '3. (Tùy chọn) Kiểm tra thông số & dung lượng GLB cục bộ',
      validating: 'đang kiểm tra…',
      checkingGlb: 'đang kiểm tra định dạng GLB…',
      validGlb: 'glTF 2.0 Binary hợp lệ',
      descriptionLabel: 'Mô tả (Tùy chọn)',
      descriptionPlaceholder: 'Chi tiết ánh sáng, đặc điểm kiến trúc, hoặc kích thước phòng',
      saving: 'Đang lưu phòng…',
      saveAndSelect: 'Lưu & chọn phòng',
      errors: {
        missingSource: 'Vui lòng nhập liên kết Google Drive, File ID, hoặc URL mô hình 3D.',
        glbValidationFailed: 'Xác thực tệp GLB thất bại.',
        networkError: 'Lỗi mạng khi tạo phòng.',
      },
      validation: {
        tooLarge: 'Tệp có dung lượng {sizeMb} MB — vượt quá giới hạn tối đa 200 MB. Hãy giảm số lượng đa giác hoặc kích thước texture rồi xuất lại.',
        notGlb: 'Tệp này có vẻ không phải là GLB hợp lệ. 4 byte đầu tiên phải là "glTF". Hãy đảm bảo bạn đã xuất tệp dưới dạng glTF Binary (.glb), không phải .gltf.',
        sizeWarning: 'Tệp có dung lượng {sizeMb} MB — vượt quá ngân sách khuyến nghị 100 MB. Hãy giảm kích thước texture hoặc giảm số lượng đa giác trước khi tải lên.',
      },
    },
    hotspotTransitionPreview: {
      liveTitle: 'Xem trước trực tiếp hiệu ứng chuyển cảnh {transition}',
      liveSimulation: 'Mô phỏng trực tiếp',
    },
    model3dHotspotEditor: {
      instructions: 'Nhấn vào mô hình để đặt một điểm ghim, nhấn vào điểm ghim vàng để chỉnh sửa, hoặc nhấn lại lên bề mặt để di chuyển điểm ghim đang chọn.',
      loading: 'Đang tải mô hình 3D…',
      loadFailed: 'Không thể tải mô hình.',
      loadFailedWithDetail: 'Không thể tải mô hình: {detail}',
    },
    setupSheet: {
      title: 'Cài đặt triển lãm',
      publicLink: 'Liên kết công khai:',
      titleLabel: 'Tên triển lãm *',
      curatorLabel: 'Tên người quản lý',
      curatorPlaceholder: 'ví dụ: Elena Rostova',
      roomLabel: 'Không gian / Phòng trưng bày 3D *',
      chooseRoom: '-- Chọn không gian trưng bày 3D --',
      publicSuffix: '(Công khai)',
      customSuffix: '(Tùy chỉnh)',
      ambientAudioLabel: 'Âm thanh nền phòng (Tùy chọn)',
      driveOrIdPlaceholder: 'Dán liên kết Google Drive hoặc file ID',
      pickAudio: 'Chọn âm thanh',
      ambientAudioHint: 'Phát lặp lại khi khách tham quan vào triển lãm. Tự động lặp lại.',
      spawnPointTitle: 'Điểm xuất phát 3D ban đầu',
      customStart: 'Xuất phát tùy chỉnh: {coords}',
      roomDefaultStart: 'Mặc định của phòng: {coords}',
      defaultEntrance: 'Vị trí lối vào mặc định của phòng',
      resetSpawnTitle: 'Đặt lại điểm xuất phát tùy chỉnh về mặc định của phòng',
      resetToDefault: 'Đặt lại mặc định',
      formatLabel: 'Định dạng triển lãm',
      formatAriaLabel: 'Triển lãm cá nhân hoặc nhóm',
      formatSolo: 'Nghệ sĩ đơn',
      formatGroup: 'Nhóm / Tập thể',
      artistsInExhibition: 'Họa sĩ trong triển lãm',
      artistCount: '{count} hồ sơ họa sĩ đã cấu hình.',
      manageArtists: 'Quản lý họa sĩ',
      descriptionLabel: 'Lời giới thiệu / Mô tả của người quản lý',
      descriptionPlaceholder: 'Nhập lời giới thiệu trên tường hoặc tổng quan hồi cố…',
      introVideoLabel: 'File ID hoặc URL video giới thiệu (Tùy chọn)',
      pasteDriveOrId: 'Dán liên kết Google Drive hoặc ID',
      pickVideo: 'Chọn video',
      introTransitionLabel: 'Hiệu ứng chuyển cảnh giới thiệu',
      saving: 'Đang lưu…',
      saveDetails: 'Lưu chi tiết triển lãm',
      toastSaved: 'Đã lưu cài đặt triển lãm thành công.',
      errors: {
        missingTitle: 'Tiêu đề triển lãm không được để trống.',
        saveFailed: 'Lỗi lưu cài đặt: {detail}',
        networkError: 'Lỗi kết nối khi lưu cài đặt triển lãm.',
      },
      introPreview: {
        liveLabel: 'Xem trước hiệu ứng trực tiếp',
        replayTitle: 'Phát lại hiệu ứng chuyển cảnh',
        replay: 'Phát lại',
        galleryWall: 'Tường trưng bày',
        galleryRoom: 'Phòng trưng bày 3D',
        curatorIntroVideo: 'Video giới thiệu của người quản lý',
        phaseVideo: '1. Đang phát video',
        phaseTransitioning: '2. Đang chuyển cảnh (2.0s)…',
        phaseGallery: '3. Đã vào không gian 3D',
      },
    },
    artistInspector: {
      newProfile: 'Hồ sơ họa sĩ mới',
      newProfileHint: 'Thêm tiểu sử họa sĩ và thông tin ghi công',
      portfolioBio: 'Danh mục & tiểu sử họa sĩ',
      portraitAlt: 'Chân dung',
      pickPortrait: 'Chọn chân dung',
      nameLabel: 'Tên họa sĩ *',
      namePlaceholder: 'ví dụ: Trần Văn Cẩn',
      datesLabel: 'Niên đại / Năm hoạt động',
      datesPlaceholder: 'ví dụ: 1910–1994',
      quoteLabel: 'Câu nói của họa sĩ',
      quotePlaceholder: 'ví dụ: Nghệ thuật là tinh túy của cuộc sống...',
      bioLabel: 'Tiểu sử',
      bioPlaceholder: 'Tiểu sử người quản lý...',
      contactLabel: 'Liên hệ / Web / Mạng xã hội',
      contactPlaceholder: 'ví dụ: Hà Nội | website.com | @handle',
      assignedWorks: 'Tác phẩm được gán ({count})',
      clickToEdit: 'Nhấn để chỉnh sửa ở chế độ Quản lý',
      noLinkedWorks: 'Chưa có tác phẩm nào được liên kết với họa sĩ này. Liên kết tác phẩm ở chế độ Quản lý.',
      editInCurateMode: 'Chỉnh sửa "{title}" ở chế độ Quản lý',
      inRoom: 'Trong phòng',
      storage: 'Lưu kho',
      saving: 'Đang lưu…',
      addArtist: 'Thêm họa sĩ',
      saveProfile: 'Lưu hồ sơ',
      confirmDelete: 'Bạn có chắc muốn xóa hồ sơ của "{name}" không?',
      toastCreated: 'Đã thêm hồ sơ họa sĩ "{name}".',
      toastUpdated: 'Đã lưu thay đổi hồ sơ họa sĩ "{name}".',
      toastDeleted: 'Đã xóa hồ sơ họa sĩ "{name}".',
      errors: {
        missingName: 'Tên họa sĩ không được để trống.',
        createFailed: 'Lỗi tạo hồ sơ: {detail}',
        updateFailed: 'Lỗi cập nhật hồ sơ: {detail}',
        deleteFailed: 'Lỗi xóa họa sĩ: {detail}',
        saveNetworkError: 'Lỗi kết nối khi lưu hồ sơ họa sĩ.',
        deleteNetworkError: 'Lỗi kết nối khi xóa hồ sơ họa sĩ.',
      },
    },
    workbenchTopBar: {
      backToDashboard: 'Quay lại trang tổng quan triển lãm',
      exhibitions: 'Triển lãm',
      viewModeAria: 'Chế độ xem',
      modeArtworks: 'Tác phẩm',
      modeArtworksTitle: 'Định vị, xoay và co giãn tác phẩm trên tường',
      modeWaypoints: 'Điểm mốc',
      modeWaypointsTitle: 'Đặt và tinh chỉnh điểm xuất phát và các điểm mốc tham quan',
      saved: 'Đã lưu',
      preview: 'Xem trước',
      share: 'Chia sẻ',
      unpublish: 'Gỡ xuất bản',
      publishing: 'Đang xuất bản…',
      publish: 'Xuất bản',
      dashboard: 'Trang tổng quan',
    },
    workbench: {
      loading: 'Đang tải bàn làm việc…',
      toastPublished: 'Triển lãm đã được xuất bản công khai.',
      toastPublishedTitle: 'Xuất bản thành công',
      toastPublishedAction: 'Chia sẻ / Xem',
      toastUnpublished: 'Triển lãm đã chuyển về chế độ bản nháp (Unpublished).',
      toastRoomChanged: 'Đã đổi không gian sang "{name}".',
      publicRoom: 'Phòng công khai',
      customSpace: 'Không gian tùy chỉnh',
      badgeWaypoints: 'Chế độ điểm mốc · Lối đi & xuất phát của khách tham quan',
      badgeArtworks: 'Chế độ tác phẩm · Sắp đặt',
      autoSaved: 'Tự động lưu',
      errors: {
        publishFailed: 'Không thể cập nhật trạng thái xuất bản.',
        publishNetworkError: 'Lỗi kết nối khi cập nhật trạng thái xuất bản.',
        roomChangeFailed: 'Không thể đổi phòng trưng bày.',
        roomChangeNetworkError: 'Lỗi mạng khi đổi phòng trưng bày.',
      },
    },
    artworkForm: {
      roomPlacement: 'Sắp đặt trong phòng',
      placedInRoom: 'Đã đặt trong phòng 3D',
      inStorageUnplaced: 'Đang lưu kho (Chưa đặt)',
      moveToStorageTitle: 'Chuyển tác phẩm này vào kho (gỡ khỏi phòng 3D)',
      placeInRoomTitle: 'Đặt tác phẩm này vào phòng trưng bày 3D',
      moveToStorage: 'Chuyển vào kho',
      placeInRoom: 'Đặt trong phòng',
      liveFramePreview: 'Xem trước khung tranh trực tiếp',
      framedPreviewAlt: 'Xem trước khung tranh',
      interactiveHotspots: 'Điểm chi tiết tương tác',
      hotspotsPinnedOnModel: '{count} điểm chi tiết được ghim trên mô hình',
      hotspotsPinnedOnCanvas: '{count} điểm chi tiết được ghim trên tranh',
      editHotspots: 'Chỉnh sửa điểm chi tiết',
      mediumTypeLabel: 'Loại tác phẩm',
      mediumTypeAria: 'Loại chất liệu tác phẩm',
      type2d: 'Tranh / Ảnh 2D',
      typeVideo: 'Video',
      type3d: 'Mô hình 3D',
      imageLinkLabel: 'Liên kết Google Drive hoặc File ID hình ảnh',
      pickFromDrive: 'Chọn từ Drive',
      driveOrIdPlaceholder: 'https://drive.google.com/file/d/... hoặc file ID',
      serviceAccountHint: 'Đảm bảo tệp đã được chia sẻ với tài khoản dịch vụ Reda trên Google Drive.',
      youtubeLinkLabel: 'Liên kết video YouTube hoặc Video ID',
      youtubePreviewAlt: 'Xem trước video YouTube',
      modelLinkLabel: 'Liên kết Google Drive hoặc File ID mô hình 3D (.glb)',
      audioGuideLabel: 'Thuyết minh âm thanh (Tùy chọn Google Drive File ID)',
      audioGuidePlaceholder: 'Liên kết Google Drive hoặc ID cho thuyết minh / âm thanh tùy chọn',
      frameSettingsTitle: 'Cài đặt khung & bảng chú thích',
      frameMaterial: 'Chất liệu khung',
      frameWood: 'Gỗ tự nhiên',
      frameGold: 'Vàng cầu kỳ',
      frameMetalBlack: 'Đen nhám',
      frameFloatWhite: 'Trắng tối giản',
      frameCanvasWrap: 'Bọc canvas',
      frameNone: 'Không khung',
      frameWidth: 'Độ rộng khung (m)',
      showPlacard: 'Hiển thị bảng chú thích dưới tác phẩm',
      allowTilt: 'Bật nghiêng phối cảnh 3D ở chế độ xem chi tiết',
      artworkInfoTitle: 'Thông tin tác phẩm',
      titleLabel: 'Tiêu đề *',
      titlePlaceholder: 'Tiêu đề tác phẩm',
      linkedArtistLabel: 'Liên kết hồ sơ họa sĩ trong triển lãm',
      noLinkedArtist: '-- Không liên kết hồ sơ họa sĩ --',
      mediumLabel: 'Chất liệu',
      mediumPlaceholder: 'ví dụ: Sơn dầu trên vải lanh, Canvas kỹ thuật số',
      yearLabel: 'Năm',
      yearPlaceholder: 'ví dụ: 2024',
      dimensionsLabel: 'Kích thước vật lý',
      dimensionsPlaceholder: 'ví dụ: 120 × 90 cm',
      descriptionLabel: 'Mô tả / Lời bình của người quản lý',
      descriptionPlaceholder: 'Bối cảnh, ghi chú lịch sử, hoặc ngữ cảnh chủ đề hiển thị trong bảng chi tiết',
      deleteTitle: 'Xóa vĩnh viễn tác phẩm khỏi triển lãm này',
      saving: 'Đang lưu…',
      saveChanges: 'Lưu thay đổi',
      addToExhibition: 'Thêm vào triển lãm',
      untitled: 'Chưa đặt tên',
      thisArtwork: 'tác phẩm này',
      confirmDelete: 'Bạn có chắc muốn xóa vĩnh viễn "{title}" không?',
      toastRemoved: 'Đã gỡ bỏ tác phẩm "{title}" khỏi triển lãm.',
      toastSaved: 'Đã lưu thay đổi tác phẩm.',
      toastAdded: 'Đã thêm tác phẩm vào triển lãm.',
      errors: {
        invalidImage: 'Vui lòng cung cấp link hình ảnh hoặc Google Drive ID hợp lệ.',
        invalidYoutube: 'Vui lòng cung cấp link YouTube hoặc video ID 11 ký tự hợp lệ.',
        missingModel: 'Vui lòng chọn một tệp mô hình 3D (.glb) từ Google Drive.',
        proxyStillGenerating: 'Đang tạo bản proxy 3D, vui lòng đợi trước khi lưu.',
        deleteFailed: 'Không thể xóa tác phẩm.',
        deleteNetworkError: 'Lỗi kết nối khi xóa tác phẩm.',
        saveFailed: 'Lỗi lưu tác phẩm: {detail}',
        saveNetworkError: 'Lỗi kết nối khi lưu tác phẩm.',
      },
      model3d: {
        generatingProxy: 'Đang tạo bản proxy nhẹ cho mô hình 3D…',
        processingTitle: 'Xử lý mô hình 3D',
        proxyReady: 'Mô hình 3D đã sẵn sàng — proxy nhẹ đã được tạo và tải lên.',
        uploadSuccessTitle: 'Tải mô hình thành công',
        proxyGenerationFailed: 'Không thể tạo bản proxy nhẹ.',
        errors: {
          glbCompressed: 'Không thể đọc tệp .glb này. Nếu tệp dùng nén Draco hoặc meshopt, vui lòng xuất lại dưới dạng .glb không nén — các tệp đã nén hiện chưa được hỗ trợ.',
          driveAuthExpired: 'Phiên xác thực Google Drive đã hết hạn — vui lòng mở lại trình chọn tệp và thử lại.',
        },
        processingErrorTitle: 'Lỗi xử lý mô hình 3D',
        generatingProxyShort: 'Đang tạo bản proxy tối ưu…',
        proxyReadyShort: 'Proxy đã sẵn sàng ({id}).',
        proxyGenerationFailedShort: 'Không thể tạo bản proxy tối ưu.',
      },
    },
    hotspotEditor: {
      title: 'Trình chỉnh sửa điểm chi tiết tương tác',
      artworkLabel: 'Tác phẩm: {title}',
      transitionSaved: 'Đã lưu hiệu ứng chuyển cảnh',
      transitionAnimationLabel: 'Hiệu ứng chuyển cảnh:',
      saving: 'Đang lưu…',
      existingHotspots: 'Điểm chi tiết hiện có ({count})',
      untitledHotspot: 'Điểm chi tiết chưa đặt tên',
      canvasInstruction: 'Nhấn vào bất kỳ đâu trên tranh để đặt một điểm chi tiết diễn giải mới.',
      zoomGroup: 'Thu phóng ảnh',
      zoomIn: 'Phóng to',
      zoomOut: 'Thu nhỏ',
      zoomFit: 'Vừa khung',
      dragToReposition: 'Kéo để di chuyển vị trí',
      noImage: 'Không có tệp hình ảnh nào gắn với tác phẩm này.',
      doneEditing: 'Hoàn tất chỉnh sửa điểm chi tiết',
      newPinTitle: 'Điểm chi tiết mới',
      locationModelSurface: 'Vị trí: đã đặt trên bề mặt mô hình 3D',
      locationXY: 'Vị trí: X: {x}%, Y: {y}%',
      hotspotTitleLabel: 'Tiêu đề điểm chi tiết',
      titlePlaceholder: 'ví dụ: Chữ ký, Vết rạn men, Biểu tượng',
      interpretiveTextLabel: 'Nội dung diễn giải',
      descriptionPlaceholder: 'Mô tả hiển thị khi khách tham quan nhấn vào điểm này',
      audioSegmentLabel: 'Phương án A: Đoạn thuyết minh âm thanh (giây)',
      startPlaceholder: 'Bắt đầu (ví dụ: 42.5)',
      stopPlaceholder: 'Kết thúc (tùy chọn)',
      to: 'đến',
      audioSegmentHint: 'Nhảy đến một điểm trong thuyết minh chính. Để trống Kết thúc để phát đến hết.',
      dedicatedAudioLinkLabel: 'Phương án B: Liên kết tệp âm thanh riêng (Google Drive / URL)',
      pickAudioFromDrive: 'Chọn âm thanh từ Google Drive',
      audioUrlPlaceholder: 'https://drive.google.com/file/d/... hoặc URL âm thanh trực tiếp',
      dedicatedAudioHint: 'Bạn có thể cung cấp một đoạn thuyết minh âm thanh riêng cho điểm chi tiết này.',
      addPin: 'Thêm điểm chi tiết',
      editTitle: 'Chỉnh sửa điểm chi tiết',
      pinAnchoredModel: 'Điểm chi tiết được neo trên bề mặt mô hình 3D',
      pinAtXY: 'Vị trí: X: {x}%, Y: {y}%',
      repositionHintModel: 'Nhấn vào một vị trí mới trên mô hình 3D để di chuyển điểm này, sau đó Lưu thay đổi.',
      repositionHintImage: 'Kéo điểm được tô sáng trên hình ảnh để di chuyển vị trí, sau đó Lưu thay đổi.',
      dedicatedAudioFileLabel: 'Phương án B: Tệp âm thanh riêng',
      audioDirectUrlPlaceholder: 'Liên kết Google Drive hoặc URL trực tiếp',
      confirmDeleteQuestion: 'Xác nhận xóa?',
      saveChanges: 'Lưu thay đổi',
      emptyStateModel: 'Nhấn vào mô hình 3D để đặt một điểm chi tiết mới, hoặc chọn một điểm hiện có để chỉnh sửa hoặc xóa.',
      emptyStateImage: 'Nhấn vào hình ảnh để đặt một điểm chi tiết mới, hoặc nhấn vào một điểm hiện có để chỉnh sửa hoặc xóa.',
      totalHotspots: 'Tổng số điểm chi tiết trên tác phẩm này: {count}',
      deletedMsg: 'Đã xóa "{title}"',
      hotspotFallback: 'điểm chi tiết',
      undo: 'Hoàn tác',
      defaultTitle: 'Điểm chi tiết',
      detailFallback: 'Chi tiết',
      errors: {
        updateFailed: 'Lỗi cập nhật điểm chi tiết: {detail}',
        updateNetworkError: 'Lỗi kết nối khi cập nhật điểm chi tiết.',
        createFailed: 'Lỗi tạo điểm chi tiết: {detail}',
        createNetworkError: 'Lỗi kết nối khi tạo điểm chi tiết.',
        deleteFailed: 'Không thể xóa điểm chi tiết.',
        deleteNetworkError: 'Lỗi kết nối khi xóa điểm chi tiết.',
        restoreFailed: 'Không thể khôi phục điểm chi tiết.',
        restoreNetworkError: 'Lỗi kết nối khi khôi phục điểm chi tiết.',
      },
      toastUpdated: 'Đã lưu thay đổi điểm chi tiết "{title}".',
      toastCreated: 'Đã thêm điểm chi tiết "{title}".',
      toastRestored: 'Đã khôi phục điểm chi tiết "{title}".',
    },
    gizmoPlacement: {
      backToArtworks: 'Quay lại tác phẩm',
      roomBadge: 'Phòng: {name}',
      moveStartPositionTitle: 'Di chuyển vị trí xuất phát',
      movePosition: 'Di chuyển vị trí',
      rotateStartFacingTitle: 'Xoay hướng nhìn xuất phát',
      rotateFacing: 'Xoay hướng nhìn',
      setAtCameraTitle: 'Đặt điểm xuất phát trực tiếp tại vị trí camera hiện tại',
      setAtCamera: 'Đặt tại vị trí camera',
      positionGizmoTitle: 'Công cụ di chuyển vị trí',
      move: 'Di chuyển',
      rotationGizmoTitle: 'Công cụ xoay',
      rotate: 'Xoay',
      scaleGizmoTitle: 'Công cụ co giãn',
      scale: 'Co giãn',
      lockedTitle: 'Đã khóa: Tỷ lệ khung hình được giữ nguyên theo tỷ lệ',
      unlockedTitle: 'Đã mở khóa: Co giãn tự do theo từng trục',
      lockRatio: 'Khóa tỷ lệ',
      freeScale: 'Co giãn tự do',
      unfocusTitle: 'Bỏ chọn (Esc)',
      unfocus: 'Bỏ chọn',
      artworksModeIndicator: 'Chế độ tác phẩm · Nhấn vào một tác phẩm trên tường để di chuyển, co giãn hoặc xoay',
      configureKeybindingsTitle: 'Cấu hình phím tắt & điều khiển',
      controlsAndKeys: 'Điều khiển & phím tắt',
      hudTitleWaypoint: 'Điểm xuất phát & điểm mốc phòng trưng bày',
      hudTitleSelected: 'Đang chọn: {title}',
      hudTitlePlacement: 'Chế độ sắp đặt tác phẩm',
      hudStartPos: 'Vị trí xuất phát: [{x}, {y}, {z}]',
      hudFacing: 'Hướng nhìn: [{x}, {y}, {z}]',
      hudPos: 'Vị trí: [{x}, {y}, {z}]',
      hudRot: 'Xoay: [{x}, {y}, {z}]',
      hudScale: 'Co giãn: [{x}, {y}, {z}]',
      hudUnfocusedPrefix: 'Nhấn vào một tác phẩm trên tường để di chuyển, co giãn hoặc xoay. Chuyển sang',
      hudUnfocusedSuffix: 'ở trên để điều chỉnh vị trí xuất phát của khách tham quan.',
      hint: {
        middleDrag: 'Kéo chuột giữa',
        orbit: 'Xoay quanh',
        rightDrag: 'Kéo chuột phải',
        moveObject: 'Di chuyển vật thể (hoặc xoay camera khi không chọn)',
        leftClick: 'Nhấn chuột trái',
        select: 'Chọn',
        wasd: 'WASD',
        roam: 'Di chuyển tự do',
        esc: 'Esc',
        unfocus: 'Bỏ chọn',
      },
      toastSpawnSaved: 'Đã lưu điểm xuất phát: ({x}, {y}, {z})',
      errors: {
        spawnSaveFailed: 'Không thể lưu điểm xuất phát.',
        spawnSaveNetworkError: 'Lỗi kết nối khi lưu điểm xuất phát.',
      },
    },
    artistViewerPreview: {
      newArtist: 'Họa sĩ mới',
      artistNameFallback: 'Tên họa sĩ',
      curateNewDossier: 'Quản lý · Hồ sơ họa sĩ mới',
      visitorPreviewNamed: 'Xem trước khách tham quan · {name}',
      visitorPreviewDossier: 'Xem trước khách tham quan · Hồ sơ họa sĩ',
      deviceViewportAria: 'Xem trước thiết bị',
      previewPcTitle: 'Xem trước dạng máy tính / PC',
      previewMobileTitle: 'Xem trước dạng di động nằm ngang',
      pcView: 'Xem trên PC',
      mobileLandscape: 'Di động nằm ngang',
      archiveDossier: 'Lưu trữ · Hồ sơ họa sĩ',
      noArtistSelected: 'Chưa chọn họa sĩ',
      noArtistHint: 'Chọn một họa sĩ từ danh sách bên trái hoặc tạo hồ sơ mới để xem trước tiểu sử, chân dung và câu nói sẽ hiển thị với khách tham quan trong phòng trưng bày 3D như thế nào.',
      closeArtistProfile: 'Đóng hồ sơ họa sĩ',
      bioUnavailable: 'Chưa có tiểu sử cho họa sĩ này.',
      worksInExhibition: 'Tác phẩm trong triển lãm ({count})',
    },
  },
  viewer: {
    untitledArtist: 'Họa sĩ chưa xác định',
    hud: {
      openingExhibitionAria: 'Đang mở triển lãm…',
      galleryCanvasAria: 'Không gian trưng bày 3D',
      movementInstructionsAria: 'Hướng dẫn di chuyển',
      toggleCameraModeTitle: 'Chuyển đổi chế độ camera (Phím tắt: C)',
      fpsMode: 'Chế độ FPS',
      galleryMode: 'Chế độ phòng trưng bày',
      walk: 'di chuyển',
      mouseLooks: 'Chuột để nhìn xung quanh',
      clickArtToFocus: 'Nhấn vào tác phẩm để xem chi tiết',
      unlockCursor: 'mở khóa con trỏ',
      drag: 'Kéo',
      look: 'để nhìn',
      clickArtBold: 'Nhấn vào tác phẩm',
      toFocusAngle: 'để xem chi tiết (90°)',
      clickFloorBold: 'Nhấn vào sàn',
      toTeleport: 'để dịch chuyển',
      gallerySettings: 'Cài đặt phòng trưng bày',
      catalog2d: 'Danh mục 2D',
      exhibitionAlt: 'Triển lãm 3D: {title}',
    },
    focus: {
      controlsAria: 'Điều khiển chế độ xem chi tiết',
      exitDetailView: 'Thoát xem chi tiết',
      exitFocusViewTitle: 'Thoát chế độ xem chi tiết',
      showArtworkInfoAria: 'Hiện thông tin tác phẩm',
      closeArtworkInfoAria: 'Đóng thông tin tác phẩm',
      artworkDetailsTitle: 'Chi tiết tác phẩm',
      pauseNarrationTitle: 'Tạm dừng thuyết minh',
      playNarrationTitle: 'Phát thuyết minh',
      pauseAudioNarrationAria: 'Tạm dừng thuyết minh âm thanh',
      playAudioNarrationAria: 'Phát thuyết minh âm thanh',
      artworkInfoAria: 'Thông tin tác phẩm: {title}',
      closeInfoCard: 'Đóng thẻ thông tin',
      mediumLabel: 'Chất liệu:',
      dimensionsLabel: 'Kích thước:',
      readArtistBioTitle: 'Đọc tiểu sử của {name}',
      readArtistBio: 'Đọc tiểu sử họa sĩ',
      openCinemaMode: 'Mở chế độ rạp chiếu',
      inspectIn360: 'Xem chi tiết 360°',
      inspectFullResolution: 'Xem chi tiết độ phân giải đầy đủ',
      navigationAria: 'Điều hướng tác phẩm',
      previousArtwork: 'Tác phẩm trước',
      nextArtwork: 'Tác phẩm tiếp theo',
    },
    inspect: {
      dialogAria: 'Xem chi tiết: {title}',
      detailCounter: 'Chi tiết {current} / {total}',
      inspectModeEyebrow: 'Chế độ xem chi tiết',
      aboutArtist: 'Về {name}',
      readAboutArtistTitle: 'Đọc về {name}',
      toggleHotspotsDirectory: 'Bật/tắt danh mục điểm nhấn',
      hotspotsListCount: 'Danh sách điểm nhấn ({count})',
      closeInspectAria: 'Đóng chế độ xem chi tiết',
      exitInspectModeTitle: 'Thoát chế độ xem chi tiết',
      hotspotsDirectoryAria: 'Danh mục điểm nhấn',
      hotspotsDirectoryTitle: 'Danh mục điểm nhấn',
      closeDirectoryAria: 'Đóng danh mục',
      clickDetailToZoom: 'Nhấn vào một điểm chi tiết để phóng to và xem kỹ.',
      audioAttached: 'Có âm thanh',
      resetViewTitle: 'Đặt lại thu phóng, nghiêng và khung hình',
      resetView: 'Đặt lại khung hình',
      tiltActiveTitle: 'Đang nghiêng: kéo để xoay góc 3D. Nhấn để chuyển sang chế độ kéo.',
      toggle3dTiltTitle: 'Bật/tắt nghiêng phối cảnh 3D',
      tiltActive: 'Đang nghiêng',
      tilt3d: 'Nghiêng 3D',
      previousDetailTitle: 'Chi tiết trước',
      prev: 'Trước',
      openHotspotsDirectoryTitle: 'Nhấn để mở danh mục điểm nhấn',
      detailsCount: 'Chi tiết ({count})',
      overview: 'Tổng quan',
      detailListLabel: '{index}. {title}',
      nextDetailTitle: 'Chi tiết tiếp theo',
      next: 'Tiếp',
      pauseDetailAudioTitle: 'Tạm dừng âm thanh chi tiết',
      listenDetailAudioTitle: 'Nghe âm thanh chi tiết',
      pauseClip: 'Tạm dừng',
      listen: 'Nghe',
      jumpToMainGuideTitle: 'Chuyển đến {sec}s trong thuyết minh chính',
      guideSeconds: 'Thuyết minh ({sec}s)',
      seeFullDescriptionTitle: 'Xem mô tả đầy đủ',
      seeMore: '... Xem thêm',
      seeLess: 'Thu gọn',
      hintCinema: 'Chế độ rạp chiếu · Nhấn Esc hoặc nhấn chuột để quay lại phòng trưng bày',
      hintMobileTiltActive: 'Kéo để nghiêng 3D · Chụm để thu phóng · Nhấn "Đang nghiêng" để quay lại kéo',
      hintMobileTiltInactive: 'Kéo để di chuyển · Chụm để thu phóng · Nhấn "Nghiêng 3D" để nghiêng góc',
      hintMobilePanOnly: 'Kéo để di chuyển · Chụm để thu phóng',
      hintDesktopTilt: 'Kéo chuột trái để di chuyển · Kéo chuột phải để nghiêng · Cuộn để thu phóng',
      hintDesktopPanOnly: 'Kéo chuột trái để di chuyển · Cuộn để thu phóng',
      sidebar: {
        detailsAria: 'Chi tiết điểm nhấn',
        detailCounter: 'Chi tiết {current} / {total}',
        dragToMove: '(Kéo để di chuyển)',
        expandFullPanelTitle: 'Mở rộng toàn bộ bảng',
        minimizeToCompactTitle: 'Thu gọn thành thẻ nhỏ',
        expand: 'Mở rộng',
        minimize: 'Thu gọn',
        closePanelTitle: 'Đóng bảng',
        dedicatedAudioLabel: 'Âm thanh chi tiết riêng',
        jumpToMainGuide: 'Chuyển đến {sec}s trong thuyết minh chính',
        prev: 'Trước',
        next: 'Tiếp',
      },
    },
    model360: {
      dialogAria: 'Xem 360°: {title}',
      eyebrow: 'Xem chi tiết 360°',
      toggleHotspotsDirectory: 'Bật/tắt danh mục điểm nhấn',
      hotspotsListCount: 'Danh sách điểm nhấn ({count})',
      closeAria: 'Đóng xem 360°',
      exitTitle: 'Thoát xem 360°',
      hotspotsDirectoryAria: 'Danh mục điểm nhấn',
      hotspotsDirectoryTitle: 'Danh mục điểm nhấn',
      closeDirectoryAria: 'Đóng danh mục',
      clickDetailToOrbit: 'Nhấn vào một điểm chi tiết để xoay và xem kỹ.',
      audioAttached: 'Có âm thanh',
      loadingModel: 'Đang tải mô hình 3D…',
      noModelFile: 'Không có tệp mô hình khả dụng.',
      failedToLoadWithMsg: 'Không thể tải mô hình 3D: {error}',
      failedToLoadGeneric: 'Không thể tải mô hình 3D.',
      hint: 'Kéo chuột trái để xoay quanh · Kéo chuột phải để di chuyển · Cuộn để thu phóng',
      hotspotLabel: 'Điểm nhấn: {title}',
    },
    catalog: {
      exhibitionCatalogAria: 'Danh mục triển lãm',
      curatedBy: 'Người quản lý: {name}',
      showing2dAccessible: 'Đang hiển thị danh mục 2D dễ tiếp cận.',
      webglRequiredNotice: 'Chế độ xem 3D yêu cầu WebGL2. Đang hiển thị danh mục 2D.',
      enter3dGallery: 'Vào phòng trưng bày 3D',
      audioGuideAria: 'Thuyết minh: {title}',
    },
    audio: {
      ariaLabel: 'Thuyết minh: {title}',
      kicker: 'Thuyết minh',
      pauseNarrationAria: 'Tạm dừng thuyết minh',
      playNarrationAria: 'Phát thuyết minh',
      pauseNarrationTitle: 'Tạm dừng thuyết minh',
      playNarrationTitle: 'Phát thuyết minh âm thanh',
      progressSliderAria: 'Thanh trượt tiến trình âm thanh',
      muteToggle: 'Tắt tiếng',
      unmuteToggle: 'Bật tiếng',
      defaultTitle: 'Thuyết minh âm thanh',
    },
    artist: {
      closeProfileAria: 'Đóng hồ sơ họa sĩ',
      bioUnavailable: 'Chưa có tiểu sử cho họa sĩ này.',
    },
    intro: {
      dialogAria: 'Giới thiệu triển lãm',
      loadingSpace: 'Đang tải không gian triển lãm 3D…',
      defaultTitle: 'Triển lãm ảo',
      curatedBy: 'Người quản lý: {name}',
      enterExhibitionAria: 'Vào triển lãm',
      enterExhibition: 'Vào triển lãm',
      preparingGallerySpace: 'Đang chuẩn bị không gian phòng trưng bày 3D…',
      finalizingTextures: 'Đang hoàn thiện chất liệu tác phẩm 3D…',
    },
    loadingCurtain: {
      dialogAria: 'Đang tải triển lãm',
      emblemAlt: 'Reda Gallery',
      defaultTitle: 'Triển lãm ảo',
      curatedBy: 'Người quản lý: {name}',
      openingArchive: 'Đang mở kho lưu trữ triển lãm…',
      streamingGeometry: 'Đang truyền tải hình học không gian 3D…',
      illuminating: 'Đang chiếu sáng đèn & khung tranh phòng trưng bày…',
      galleryPrepared: 'Phòng trưng bày đã sẵn sàng',
    },
    error: {
      dialogAria: 'Lỗi triển lãm',
      notFoundTitle: 'Không tìm thấy triển lãm',
      notFoundMessage: 'Liên kết triển lãm không tồn tại hoặc đã được chuyển sang phòng trưng bày khác.',
      privateTitle: 'Triển lãm riêng tư',
      privateMessage: 'Triển lãm này hiện đang trong quá trình chuẩn bị hoặc chỉ mở cho người được ủy quyền.',
      networkTitle: 'Lỗi kết nối không gian',
      networkMessage: 'Không thể tải dữ liệu không gian triển lãm. Vui lòng kiểm tra đường truyền và thử lại.',
      returnHome: 'Quay lại trang chủ',
      studioLogin: 'Đăng nhập Studio',
      retryConnection: 'Thử lại kết nối',
    },
    joystick: {
      ariaLabel: 'Cần điều khiển ảo',
      move: 'Di chuyển',
    },
    settings: {
      dialogAria: 'Cài đặt trình xem',
      header: 'Cài đặt phòng trưng bày & điều khiển',
      closeAria: 'Đóng cài đặt',
      cameraDisplay: 'Camera & Hiển thị',
      fov: 'Góc nhìn (FOV)',
      fovAria: 'Góc nhìn (FOV)',
      narrow: 'Hẹp (50°)',
      defaultLabel: 'Mặc định (65°)',
      wide: 'Rộng (90°)',
      movementSpeed: 'Tốc độ di chuyển (WASD / Mũi tên)',
      walkingSpeed: 'Tốc độ đi bộ',
      walkingSpeedAria: 'Tốc độ đi bộ',
      slow: 'Chậm',
      normal: 'Bình thường',
      fast: 'Nhanh',
      sprintSpeed: 'Tốc độ chạy (Giữ Shift)',
      sprintSpeedAria: 'Tốc độ chạy',
      desktopControls: 'Camera & nhìn bằng chuột (Máy tính)',
      cameraControlMode: 'Chế độ điều khiển Camera',
      fpsPointerLock: 'FPS (Khóa con trỏ)',
      galleryDragLook: 'Phòng trưng bày (kéo để nhìn)',
      galleryModeBtn: 'Chế độ phòng trưng bày',
      fpsModeBtn: 'Chế độ FPS (Khóa con trỏ)',
      mouseSensitivity: 'Độ nhạy chuột',
      mouseSensitivityAria: 'Độ nhạy chuột',
      invertHorizontal: 'Đảo ngược chiều ngang (X)',
      invertVertical: 'Đảo ngược chiều dọc (Y)',
      mobileTouch: 'Điều khiển chạm trên di động',
      resetDefaults: 'Đặt lại mặc định',
      done: 'Xong',
    },
    hotspot: {
      closeAria: 'Đóng điểm nhấn',
      interpretivePoint: 'Điểm diễn giải',
      jumpToAudioGuide: 'Chuyển đến {sec}s trong thuyết minh',
      label: 'Điểm nhấn: {title}',
    },
  },
};

type DeepStringShape<T> = { [K in keyof T]: T[K] extends string ? string : DeepStringShape<T[K]> };
export type Dict = DeepStringShape<typeof vi>;
export type Lang = 'vi' | 'en';
